/**
 * Collection of datapoints used by confetti
 */
export default {
    // Confetti is triggered when an unread message is open
    ConfettiTriggeredAutomatically: {
        datapoint: {
            name: 'Confetti_TriggeredAutomatically',
            customData: (keyword: string) => [
                keyword, // 1. The keyword that triggered the confetti
            ],
        },
    },

    // Confetti is triggered when a user hovers over a keyword
    ConfettiTriggeredManually: {
        datapoint: {
            name: 'Confetti_TriggeredManually',
            customData: (keyword: string) => [
                keyword, // 1. The keyword that triggered the confetti
            ],
        },
    },

    // A highlight is shown on a confetti keyword
    ConfettiKeywordHighlighted: {
        datapoint: {
            name: 'Confetti_KeywordHighlighted',
            customData: (keyword: string) => [
                keyword, // 1. The keyword that triggered the confetti
            ],
        },
    },

    // Confetti is disabled in the user settings
    ConfettiSettingDisabled: {
        datapoint: {
            name: 'Confetti_SettingDisabled',
        },
    },
};
